import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import ShowAlert from "../alert";
import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { exportToExcel} from "../utils/commonFunctions";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { Row, Col, Button, Container } from 'react-bootstrap';
import { Link } from "@mui/material";

const GVAReport = () => {


  const [mainEnb, setMainEnb] = useState(false);
  const [searchText, setSearch] = useState("");
  const [data, setData] = useState();
  const [distlist, setDistrictList] = useState([]);
  const [distEnb, setDistEnb] = useState(false);
  const [data1, setData1] = useState()
  const [SubEnbmandal, setSubenbmandal] = useState(false)
  const [searchText1, setSearch1] = useState("");

  const [districtNames, setDistrictNames] = useState([]);
  const [mandalNames, setMandalNames] = useState([]);
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const formik = useFormik({
    initialValues: {
      district_id: ""
    },

  })

  React.useEffect(() => {
    if ((roleid === "2") || (roleid === "10")) {
      setDistEnb(true)

    }
    if (roleid === "3") {
      setDistEnb(true)

    }
    if (roleid === "5") {
      setDistEnb(false)

    }
    formik.setFieldValue("district_id", district !== "0" ? district : "");

   
    

  }, [])

  

useEffect(() => {
    MasterService.getDistricts().then((res) => {
      if (res.data) {
        const options = res.data.map((item, i) => (
          <option key={i} value={item.id}>
            {item.value}
          </option>
        ));
        setDistrictList(options);
      }
    });
  
    if (["10", "2"].includes(roleid)) {
      const params = { userId: username, districtId: district };

     
     
      fetchSectorwiseReport(params);
    }
  }, [roleid, district]);
  
  const fetchSectorwiseReport = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getsectorwiseReport(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
        
        const uniqueMandalNames = [...new Set(res.data.SDESC.map(item => item.mandal_name))];
      setMandalNames(uniqueMandalNames);
      setMainEnb(false);
      setSubenbmandal(true);
      setData1(res.data.SDESC);
        }
      })
      .catch((err) => ShowAlert(err, "error"))
      .finally(() => store.dispatch({ type: "HIDE_SPINNER" }));
  };
  
  const Subdata = (district_id) => {
    formik.setFieldValue("district_id",district_id);
    const params = { userId: username, districtId: district_id };
    
    fetchSectorwiseReport(params);
  };
  
  const Admindata = (e) => {
    const district_id = e.target.value;
    formik.setFieldValue("district_id", district_id);
  
    if (["5", "8"].includes(roleid) && district_id) {
      const params = {
        districtId: district_id === "0" ? null : district_id,
        userId: username,
      };
  
      if (district_id !== "0") {
        fetchSectorwiseReport(params);
      
      } else {
        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.getsectorwiseReport(params)
          .then((res) => {
            if (res.data && res.data.SCODE === "01") {
            const uniqueDistrictNames = [...new Set(res.data.SDESC.map(item => item.district_name))];
            setDistrictNames(uniqueDistrictNames);
            setMainEnb(true);
            setSubenbmandal(false);
            setData(res.data.SDESC); 
            }
          })
          .catch((err) => ShowAlert(err, "error"))
          .finally(() => store.dispatch({ type: "HIDE_SPINNER" }));
    
      }
    }
  };
  


  function generatePdf(tableid) {
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [900, 900], });
    autoTable(doc, {
      html: tableid,
      theme: "grid",
      tableWidth: 800,
      columnStyles: { 3: { cellWidth: "wrap"} },
      headStyles: { halign: "center" },
      styles: { fontSize: 8 },
    });
    doc.save("GVA Report.pdf");
  }

  

  const filteredData =
    searchText.length > 0 ? data?.filter((item) => {
      return (
        item &&
        Object.keys(item).some((key) => {
          const value = item[key];
          return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()));
        })
      );
    }) : data;


  const filteredData1 =
    searchText1.length > 0 ? data1?.filter((item) => {
      return (
        item &&
        Object.keys(item).some((key) => {
          const value = item[key];
          return (value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()));
        })
      );
    }) : data1;

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "80%" }}>
        <div className='sa-title'>
          <h2>GVA <span>Report</span></h2>
        </div>
      </Container>

      <Container fluid style={{ width: "80%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

            <div className='mandal-container p-4 mt-2'>

              <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mx-4" >
                  <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span>
                  <Field component="select" name="district_id"
                    disabled={distEnb}
                    className="form-control"
                    value={formik.values.district_id}

                    onChange={(e) => { Admindata(e) }} >
                    <option value="">--Select--</option>
                    <option value="0">All</option>
                    {distlist}
                  </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
                </Col>

              </Row>
            </div>

          </Form>
        </FormikProvider><br />


        {mainEnb &&
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-3" >
                <div class="input-group">
                  <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                  <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch(event.target.value)} />
                </div>
              </Col>

              <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
              <Button
                  variant="danger"
                  size="sm"
                  className="btn mx-2 pdf-btn"
                  onClick={() => generatePdf("#my-table")}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  PDF<MdOutlinePictureAsPdf />
                </Button>


                <Button
                  variant="success"
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                  onClick={() => exportToExcel("my-table", "GVA Report")}
                >
                  Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                </Button>

              </Col>
            </Row>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
                
             <table
  id="my-table"
  className="table table-bordered custom-table table-responsive sticky-table"
>
  <thead>
    <tr>
      <th className="sticky-col sticky-sno">Sl.No.</th>
      <th className="sticky-col sticky-indicator">Broad Sector Name</th>
      <th className="sticky-col sticky-subindicator">Sub Sector Name</th>

      {districtNames.map((district1, index) => (
        <th key={index}>{district1}</th>
      ))}
      <th>Totals</th>
    </tr>
  </thead>
  <tbody>
    {filteredData?.length === 0 || filteredData === undefined ? (
      <tr>
        <td colSpan={districtNames.length + 4} className="text-center" style={{ color: "red" }}>
          Details Not Found
        </td>
      </tr>
    ) : (
      filteredData
        .reduce((acc, detail) => {
          const existingRow = acc.find(row => row.industry_name === detail.industry_name);

          if (!existingRow) {
            acc.push({
              bs_name: detail.bs_name,
              industry_name: detail.industry_name,
              districtData: {
                [detail.district_name]: {
                  gmdp: detail.gmdp,
                  district_code: detail.district_code
                },
              },
            });
          } else {
            existingRow.districtData[detail.district_name] = {
              gmdp: detail.gmdp,
              district_code: detail.district_code
            };
          }

          return acc;
        }, [])
        .map((row, index, array) => {
          const isFirstOccurrence = index === 0 || row.bs_name !== array[index - 1].bs_name;

          const totalAchived = districtNames.reduce((sum, district3) => {
            return sum + (row.districtData[district3]?.gmdp || 0);
          }, 0);

          let totalToDisplay = totalAchived.toFixed(2);
          if (index === array.length - 1 && array.length >= 2) {
            const secondLastTotal = districtNames.reduce((sum, district) => {
              return sum + (array[array.length - 2].districtData[district]?.gmdp || 0);
            }, 0);
            const nmdpTotal = districtNames.reduce((sum, district) => {
              return sum + (array[array.length - 3].districtData[district]?.gmdp || 0);
            }, 0);
            totalToDisplay = secondLastTotal !== 0 ? Math.round((nmdpTotal / secondLastTotal)*100000) : "0";
          }

          return (
            <tr key={index}>
              <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
              <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.bs_name : ""}</td>
              <td
                style={{
                  minWidth: "200px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  textAlign: "left"
                }}
                className="sticky-col sticky-subindicator"
              >
                {row.industry_name}
              </td>

              {districtNames.map((district4, i) => (
                <td key={i} style={{ textAlign: "right" }}>
                  {row.districtData[district4] !== undefined && (
                    <Link
                      onClick={() => Subdata(row.districtData[district4].district_code)}
                      style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}
                    >
                      {row.districtData[district4].gmdp}
                    </Link>
                  )}
                </td>
              ))}

              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                {totalToDisplay}
              </td>
            </tr>
          );
        })
    )}
  </tbody>
</table>


              </div>
            </div>
          </>
        }



        {SubEnbmandal && <>
          <Row  >
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-2" style={{ marginLeft: "40px" }}>
              <div class="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch1(event.target.value)} />
              </div>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-center" >
              <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={()=>{generatePdf("#my-table1")}} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /> </Button>
              <Button
                  variant="success"
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                  onClick={() => exportToExcel("my-table1", "GVA Report")}
                >
                  Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                </Button>
            </Col>

          </Row>
          <div id="table-scroll" className="table-scroll" >
            <div className="table-wrap">
              <table bordered hover id="my-table1" className="table table-bordered custom-table table-responsive sticky-table">
                <thead>
                  <tr>
                    <th className="sticky-col sticky-sno">Sl.No.</th>
                    <th className="sticky-col sticky-indicator">Broad Sector Name</th>
                    <th className="sticky-col sticky-subindicator">Sub Sector Name</th>
                    {mandalNames.map((mandal, index) => (
                      <th key={index}>{mandal}</th>
                    ))}
                    <th>Totals</th>
                  </tr>
                </thead>
                <tbody>
  {filteredData1?.length === 0 || filteredData1 === undefined ? (
    <tr>
      <td colSpan={mandalNames.length + 4} className="text-center" style={{ color: "red" }}>
        Details Not Found
      </td>
    </tr>
  ) : (
    filteredData1
      .reduce((acc, detail) => {
        const existingRow = acc.find(row => row.industry_name === detail.industry_name);

        if (!existingRow) {
          acc.push({
            bs_name: detail.bs_name,
            industry_name: detail.industry_name,
            mandalData: {
              [detail.mandal_name]: {
                gmdp: detail.gmdp,
                mandal_code: detail.mandal_code,
              },
            },
          });
        } else {
          existingRow.mandalData[detail.mandal_name] = {
            gmdp: detail.gmdp,
            mandal_code: detail.mandal_code,
          };
        }

        return acc;
      }, [])
      .map((row, index, array) => {
        const isFirstOccurrence = index === 0 || row.bs_name !== array[index - 1].bs_name;

        const totalAchived = mandalNames.reduce((sum, mandal) => {
          return sum + (row.mandalData[mandal]?.gmdp || 0);
        }, 0);

        let totalToDisplay = totalAchived.toFixed(2);
        if (index === array.length - 1 && array.length >= 2) {
          const secondLastTotal = mandalNames.reduce((sum, mandal) => {
            return sum + (array[array.length - 2].mandalData[mandal]?.gmdp || 0);
          }, 0);
          const nmdpTotal = mandalNames.reduce((sum, mandal) => {
            return sum + (array[array.length - 3]?.mandalData[mandal]?.gmdp || 0);
          }, 0);
          totalToDisplay = secondLastTotal !== 0 ? Math.round((nmdpTotal / secondLastTotal)*100000) : "0";
        }

        return (
          <tr key={index}>
            <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
            <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.bs_name : ""}</td>
            <td style={{
              minWidth: "200px",
              wordWrap: "break-word",
              whiteSpace: "normal",
              textAlign: "left"
            }} className="sticky-col sticky-subindicator">{row.industry_name}</td>
            {mandalNames.map((mandal, i) => (
              <td key={i} style={{ textAlign: "right" }}>
                {row.mandalData[mandal]?.gmdp}
              </td>
            ))}
            <td style={{ textAlign: "right", fontWeight: "bold" }}>
              {totalToDisplay}
            </td>
          </tr>
        );
      })
  )}
</tbody>
              </table>
            </div>

          </div>
        </>

        }
      </Container>
    </>
  );
};
export default GVAReport;